module.exports = __webpack_public_path__ + "img/passport-stamps-thumbnail-circle.2fbf54fb.png";